import { apiClient } from '../config';

export default {
  getList (params) {
    return apiClient.get('/bonuses', { params });
  },
  sendBonus (taskId, params) {
    return apiClient.post(`/task/${taskId}/bonus`, params);
  },
  getBonusesProject (projectId) {
    return apiClient.get(`/bonuses/projects/${projectId}`);
  },
  getPlayers (params) {
    return apiClient.get('/bonuses/players', { params });
  },
  setBonusesProject (projectId, params) {
    return apiClient.post(`/bonuses/projects/${projectId}`, params);
  },
  bonusesReport (params) {
    return apiClient.post('/reports/bonuses', params);
  }
};
